"use strict";

module.exports = {
  'name': 'to',
  'category': 'Units',
  'syntax': ['x to unit', 'to(x, unit)'],
  'description': 'Change the unit of a value.',
  'examples': ['5 inch to cm', '3.2kg to g', '16 bytes in bits'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/units/to.js
// module id = 978
// module chunks = 0